import {
  Box,
  Flex,
  Stat,
  StatLabel,
  Text,
  useColorModeValue,
  Grid,
  GridItem,
  VStack,
  Button,
  Table,
  Tbody,
  Td,
  Tr,
  TableContainer,
  Thead,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Th,
  Heading,
  useDisclosure
} from '@chakra-ui/react'
import { FC, useState } from 'react'
import Chart from 'react-apexcharts'
import { FaBezierCurve } from 'react-icons/fa'

import useOptimizerStorange from '@hook/optimizer/use-optimizer-storange'

import SelectedTableBar from './SelectedTableBar'

const data = [
  {
    'Codigo Nivel': 'Empresa',
    Nivel: 5489229,
    'Est Realizado': 0.99,
    'Nivel Real': 239244,
    'Est Medio': 0.85
  },
  {
    'Codigo Nivel': 'Curva A',
    Nivel: 282424,
    'Est Realizado': 0.89,
    'Nivel Real': 131331,
    'Est Medio': 0.34
  },
  {
    'Codigo Nivel': 'Curva B',
    Nivel: 13131,
    'Est Realizado': 0.45,
    'Nivel Real': 13131,
    'Est Medio': 0.45
  },
  {
    'Codigo Nivel': 'Curva C',
    Nivel: 134425,
    'Est Realizado': 0.89,
    'Nivel Real': 31313,
    'Est Medio': 0.65
  },
  {
    'Codigo Nivel': 'Curva D',
    Nivel: 13131,
    'Est Realizado': 0.89,
    'Nivel Real': 13131,
    'Est Medio': 0.678
  }
]

const dataOne = [
  {
    'Categoria Compac': 'MDf',
    'Curva Abc': 'D',
    'Estoq Medio Realiz': 13,
    'Nivel de Serv Realizado': 99,
    'estoque medio otim': 5999,
    'Nivel de Servico Otimi': 98,
    'Variacao Estoque medio': 600,
    'Variacao nivel de Ser': -0.89,
    'Nivel Desejado': 0,
    'Id Categoria': 1
  },
  {
    'Categoria Compac': 'Mdf branco',
    'Curva Abc': 'D',
    'Estoq Medio Realiz': 1313,
    'Nivel de Serv Realizado': 92,
    'estoque medio otim': 31313,
    'Nivel de Servico Otimi': 98,
    'Variacao Estoque medio': 3131,
    'Variacao nivel de Ser': -0.89,
    'Nivel Desejado': 0,
    'Id Categoria': 2
  },
  {
    'Categoria Compac': 'Mdf raiz',
    'Curva Abc': 'B',
    'Estoq Medio Realiz': 414,
    'Nivel de Serv Realizado': 94,
    'estoque medio otim': 1313,
    'Nivel de Servico Otimi': 97,
    'Variacao Estoque medio': 1312,
    'Variacao nivel de Ser': -0.89,
    'Nivel Desejado': 0,
    'Id Categoria': 3
  },
  {
    'Categoria Compac': 'Mdf',
    'Curva Abc': 'C',
    'Estoq Medio Realiz': 3144,
    'Nivel de Serv Realizado': 92,
    'estoque medio otim': 13131,
    'Nivel de Servico Otimi': 4,
    'Variacao Estoque medio': 4353,
    'Variacao nivel de Ser': 12,
    'Nivel Desejado': 0,
    'Id Categoria': 4
  },
  {
    'Categoria Compac': 'Madeiras',
    'Curva Abc': 'D',
    'Estoq Medio Realiz': 123,
    'Nivel de Serv Realizado': 98,
    'estoque medio otim': 11214,
    'Nivel de Servico Otimi': 29,
    'Variacao Estoque medio': 1313,
    'Variacao nivel de Ser': 1,
    'Nivel Desejado': 0,
    'Id Categoria': 5
  },
  {
    'Categoria Compac': 'Comparcado',
    'Curva Abc': 'A',
    'Estoq Medio Realiz': 1,
    'Nivel de Serv Realizado': 90,
    'estoque medio otim': 2424,
    'Nivel de Servico Otimi': 23,
    'Variacao Estoque medio': 5353,
    'Variacao nivel de Ser': 2,
    'Nivel Desejado': 1,
    'Id Categoria': 6
  }
]

const dataFirstTable = {
  'Primeira Data de Venda': '15/01/2022',
  'Ultima Data de Venda': '27/05/2024',
  'Estoque médio, unids': '17,153.27',
  'Venda média. unids': '019.37',
  'Cobertura Média, dias': '28',
  'Lead Time dias': '27',
  'Frequencia de Compra das': '20',
  'Lote Múltiplo, unids': '42',
  'Custo Médio, R$/und': 'R$ 100,00',
  'Margem R$/und': 'R$ 13,00',
  'Politica de Estoque Otimizada dias': '3',
  'Politica de Estoque Arbitrada dias': '40'
}
const dataSecondTable = {
  'Politica de Estoque Mostrada': '40'
}

const financialData = {
  Atual: { value: 'R$ 1,718,587', percentage: '0.00%' },
  Otimizada: { value: 'R$ 691,503.00', percentage: '8,77%' },
  Arbitrada: { value: 'R$ 2,587,182', percentage: '0.03%' },
  Mostrada: { value: 'R$ 2,587,182', percentage: '0.03%' }
}

type Data = {
  [key: string]: (number | string)[]
}
const dataIndication: Data = {
  'Politica Estoque . dias': [0, 1, 2, 3, 4, 5, 6, 7, 8],
  'Politica Estoque Fir, dias': [2, 2, 5, 6, 3, 3, 3, 4, 4],
  'Custo Estoque Medio, reais': [
    507900, 12902, 12902, 9234, 123, 2324, 214, 90.9, 100244
  ],
  'Ruptura % ultimo 365 dias': [
    '11%',
    '9%',
    '900%',
    '900%',
    '0%',
    '700%',
    '800%',
    '900%',
    '700%'
  ],
  'Ruptura fit % ultimo 365 dias': [
    '12%',
    '1200%',
    '800%',
    '900%',
    '1000%',
    '1100%',
    '1200%',
    '1200%',
    '1100%'
  ]
}

export const StockInfoTable = () => {
  return (
    <Box borderWidth={1} borderRadius="lg" overflow="hidden" w="100%">
      <Heading
        fontWeight="700"
        w="100%"
        color="white"
        fontSize="14"
        size="lg"
        bg="#1d5840"
        p={4}
        borderRadius="md"
      >
        Parâmetros de Estoque
      </Heading>
      <Table size="sm" className="scl-table-grid-v2">
        <Tbody>
          {Object.entries(dataFirstTable).map(([key, value]) => (
            <Tr key={key}>
              <Td fontWeight="bold">{key}</Td>
              <Td>{value}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  )
}

export const StockInfoTableSecond = () => {
  return (
    <Box borderWidth={1} borderRadius="lg" overflow="hidden" w="100%">
      <Heading
        fontWeight="700"
        w="100%"
        color="white"
        fontSize="14"
        size="lg"
        bg="#1d5840"
        p={4}
        borderRadius="md"
      >
        Simular Politica de Estoque
      </Heading>
      <Table size="sm" className="scl-table-grid-v2">
        <Tbody>
          {Object.entries(dataSecondTable).map(([key, value]) => (
            <Tr key={key}>
              <Td fontWeight="bold">{key}</Td>
              <Td bg="yellow.100" contentEditable={true}>
                {value}
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  )
}

export const StockInfoTableThree = () => {
  return (
    <Box borderWidth={1} borderRadius="lg" overflow="hidden" w="100%">
      <Heading
        fontWeight="700"
        w="100%"
        color="white"
        fontSize="14"
        size="lg"
        bg="#1d5840"
        p={4}
        borderRadius="md"
      >
        Simular Politica de Estoque
      </Heading>
      <Table size="sm" className="scl-table-grid-v2">
        <Tbody>
          {Object.entries(financialData).map(([key, { value, percentage }]) => (
            <Tr key={key}>
              <Td fontWeight="bold">{key}</Td>
              <Td>{value}</Td>
              <Td>{percentage}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  )
}
export const DataTable = () => {
  return (
    <Box>
      <TableContainer>
        <Table size="sm" className="scl-table-grid-v2">
          <Thead bg="#1d5840" color="white" border={10} h={10} fontWeight="700">
            <Tr>
              <Th py={2} fontWeight="700">
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  Codigo Nivel
                </Text>
              </Th>
              <Th color="white" py={1} fontWeight="700">
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  Nivel
                </Text>
              </Th>
              <Th color="white" py={1} fontWeight="700">
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  Est Realizado
                </Text>
              </Th>
              <Th color="white" py={2} fontWeight="700">
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  Nivel Real
                </Text>
              </Th>
              <Th color="white" py={2} fontWeight="700">
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  Est Medio
                </Text>
              </Th>
            </Tr>
          </Thead>
          <Tbody pb={0}>
            {data.map((row, index) => (
              <Tr
                key={index}
                _hover={{ fontSize: '1.5em', fontWeight: '700' }}
                bg="gray.50"
              >
                <Td>{row['Codigo Nivel']}</Td>
                <Td>{row.Nivel}</Td>
                <Td>{row['Est Realizado']}</Td>
                <Td>{row['Nivel Real']}</Td>
                <Td>{row['Est Medio']}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  )
}

export const DataTableOne = () => {
  return (
    <Box>
      <TableContainer borderRadius="lg" border="1px" borderColor="gray.200">
        <Table size="sm" className="scl-table-grid-v2">
          <Thead bg="#1d5840" color="white" border={10} h={10} fontWeight="700">
            <Tr>
              <Th py={2} fontWeight="700">
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  Categoria Compac
                </Text>
              </Th>
              <Th color="white" py={2}>
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  Curva Abc
                </Text>
              </Th>
              <Th color="white" py={2}>
                {' '}
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  Estoq Medio Realiz
                </Text>
              </Th>
              <Th color="white" py={2}>
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  Nivel de Serv Realizado
                </Text>
              </Th>
              <Th color="white" py={2}>
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  estoque medio otim
                </Text>
              </Th>
              <Th color="white" py={2}>
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  Nivel de Servico Otimi
                </Text>
              </Th>
              <Th color="white" py={2}>
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  Variacao Estoque medio
                </Text>
              </Th>
              <Th color="white" py={2}>
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  Variacao nivel de Ser
                </Text>
              </Th>
              <Th color="white" py={2}>
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  Nivel Desejado
                </Text>
              </Th>
              <Th color="white" py={2}>
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  Id Categoria
                </Text>
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {dataOne.map((row, index) => (
              <Tr
                key={index}
                _hover={{ fontSize: '1.3em', fontWeight: '700' }}
                bg="gray.50"
              >
                <Td>{row['Categoria Compac']}</Td>
                <Td>{row['Curva Abc']}</Td>
                <Td>{row['Estoq Medio Realiz']}</Td>
                <Td>{row['Nivel de Serv Realizado']}</Td>
                <Td>{row['estoque medio otim']}</Td>
                <Td>{row['Nivel de Servico Otimi']}</Td>
                <Td
                  bg={
                    row['Variacao Estoque medio'] > 0 ? 'green.100' : 'red.100'
                  }
                >
                  {row['Variacao Estoque medio']}
                </Td>
                <Td
                  bg={
                    row['Variacao nivel de Ser'] > 0 ? 'green.100' : 'red.100'
                  }
                >
                  {row['Variacao nivel de Ser']}
                </Td>
                <Td
                  bg={
                    row['Nivel Desejado'] === 0
                      ? 'yellow.100'
                      : row['Nivel Desejado'] > 0
                      ? 'green.100'
                      : 'red.100'
                  }
                >
                  {row['Nivel Desejado']}
                </Td>
                <Td>{row['Id Categoria']}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  )
}

export const DataTableIndication = () => {
  return (
    <Box>
      <TableContainer borderRadius="lg" border="1px" borderColor="gray.200">
        <Heading
          fontWeight="700"
          w="100%"
          color="white"
          fontSize="14"
          size="lg"
          bg="#1d5840"
          p={4}
          borderRadius="md"
        >
          Indicadores
        </Heading>
        <Table size="sm" className="scl-table-grid-v2">
          <Tbody>
            {Object.keys(dataIndication).map((key, rowIndex) => (
              <Tr key={rowIndex}>
                <Td>{key}</Td>
                {dataIndication[key].map((value, colIndex) => (
                  <Td key={colIndex}>{value}</Td>
                ))}
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  )
}

const ChartTraydOff = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [selectedPoint, setSelectedPoint] = useState(null)

  const handlePointClick = (
    _event: any,
    _chartContext: any,
    // eslint-disable-next-line unused-imports/no-unused-vars
    { dataPointIndex, seriesIndex }: any
  ) => {
    setSelectedPoint({
      name: 'Reptura %',
      index: 1,
      value: 100
    })
    onOpen()
  }
  const categories = []
  for (let i = 100000; i <= 3000000; i += 100000) {
    categories.push(i.toLocaleString())
  }
  const options = {
    chart: {
      type: 'line',
      height: 350,
      events: {
        markerClick: handlePointClick
      }
    },
    xaxis: {
      categories: categories
    },
    yaxis: {
      title: {
        text: 'Ruptura (%)'
      }
    },
    markers: {
      size: 6
    },
    legend: {
      position: 'top'
    },
    series: [
      {
        name: 'Ruptura %',
        data: [null, 10, 12, null, null, 30, 40, 50],
        type: 'scatter',
        color: '#1d5840' // Verde
      },
      {
        name: 'Atual',
        data: [null, null, null, null, 35, null, null],
        type: 'scatter',
        color: '#00cc99', // Azul
        markers: {
          size: 20, // Ajustando o tamanho do marcador para a série "Atual"
          shape: 'diamond' // Forma do marcador como losango
        }
      },
      {
        name: 'Otimizada',
        data: [null, null, null, null, 22, null, null, null],
        type: 'scatter',
        color: '#FF0000' // Vermelho
      },
      {
        name: 'Arbitrada',
        data: [14, 24, 34, 44, 54],
        type: 'scatter',
        color: '#009933' // Verde Claro
      },
      {
        name: 'Mosrada',
        data: [16, 26, 36, 46, 56],
        type: 'scatter',
        color: '#cccc00' // Amarelo
      },
      {
        name: 'Ruptura Fit %',
        data: [36, 26, 16, 46, 56, 80, 90, 67, 89],
        type: 'line',
        color: '#00cc00' // Amarelo
      }
    ]
  }

  return (
    <Box>
      <Chart
        options={options as any}
        series={options.series}
        type="line"
        height={230}
        width={780}
      />
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent bg="white">
          <ModalHeader
            paddingTop={2}
            paddingBottom={2}
            paddingLeft={4}
            paddingRight={4}
            textColor={'gray.200'}
            background={'#1d5840'}
            borderTopLeftRadius={5}
            borderTopRightRadius={5}
            borderBottom="3px solid #ECC94B"
          >
            <Flex alignItems="center">
              <FaBezierCurve />
              <Text marginLeft={2}>Ponto Selecionado</Text>
            </Flex>
          </ModalHeader>
          <ModalCloseButton
            top={1}
            right={1.5}
            textColor={'gray.200'}
            size="lg"
          />
          <ModalBody>
            {selectedPoint && (
              <Text>
                Você selecionou o ponto da Ruptura % <br />
                <strong>no Ponto Y:</strong> <strong>100,00.00</strong> <br />
                <strong>no Ponto X:</strong> <strong>10</strong>.
                <br />
                Deseja continuar?
              </Text>
            )}
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="green" variant="outline" onClick={onClose}>
              Continuar
            </Button>
            <Button
              colorScheme="red"
              variant="outline"
              onClick={onClose}
              ml={3}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  )
}

const ChartSimuladoOne = () => {
  const options = {
    chart: {
      type: 'area',
      height: 350
    },
    xaxis: {
      type: 'datetime',
      categories: [
        '2023-01-01',
        '2023-02-01',
        '2023-03-01',
        '2023-04-01',
        '2023-05-01',
        '2023-06-01',
        '2023-07-01',
        '2023-08-01',
        '2023-09-01',
        '2023-10-01'
      ]
    },
    yaxis: {
      title: {
        text: 'Value'
      }
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: 'smooth'
    },
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.9,
        stops: [0, 90, 100]
      }
    },
    series: [
      {
        name: 'Estoque Simulado',
        data: [10, 15, 13, 18, 22, 20, 30, 28, 25, 32],
        color: '#1d5840' // Verde
      },
      {
        name: 'Estoque Realizado',
        data: [8, 12, 10, 15, 20, 18, 25, 24, 20, 28],
        color: '#003d66' // Cinza
      }
    ],
    legend: {
      position: 'top'
    },

    tooltip: {
      shared: true,
      intersect: false
    }
  }

  return (
    <Box>
      <Chart
        options={options as any}
        series={options.series}
        type="area"
        height={230}
        width={780}
      />
    </Box>
  )
}

const Core3Otimizador: FC = () => {
  const { selectedCategoria } = useOptimizerStorange()

  return (
    <>
      {selectedCategoria != null && (
        <>
          <SelectedTableBar
            levelSelection={selectedCategoria.level}
            curve={selectedCategoria.curve}
          />
        </>
      )}
      <Grid
        h="200px"
        templateRows="repeat(2, 1fr)"
        templateColumns="repeat(5, 1fr)"
        gap={4}
        p={4}
        pb={20}
      >
        <GridItem rowSpan={2} colSpan={2}>
          <VStack spacing={5}>
            {/* <StatsCard
              title={'Estoque Atual Total'}
              stat={'R$ 9879.080'}
              icon={<BsPerson size={'3em'} />}
            />
            <StatsCardTable title="Total Sales" stat="$1500" icon={null} />
            <CustomCard
              title="Estoque"
              subtitle1="Medio "
              value1="R$ 697,00"
              subtitle2="Percent"
              value2="10%"
              icon={<BsPerson size={24} />}
              stat={''}
            />
            <CustomCard
              title="Estoque"
              subtitle1="Medio "
              value1="R$ 697,00"
              subtitle2="Percent"
              value2="10%"
              icon={<BsPerson size={24} />}
              stat={''}
            /> */}
            <StockInfoTable />
            <StockInfoTableSecond />
            <StockInfoTableThree />
          </VStack>
        </GridItem>
        <GridItem colSpan={3} mL={10} mr={30}>
          <Stat
            // px={{ base: 2, md: 4 }}
            // py={'5'}
            shadow={'xl'}
            border={'1px solid'}
            borderColor={useColorModeValue('gray.800', 'gray.500')}
            rounded={'lg'}
          >
            <Flex
              justifyContent={'space-between'}
              direction="column"
              alignItems="center"
            >
              <Box
                bg="#1d5840"
                color="white"
                width="100%"
                textAlign="center"
                py={2}
                roundedTop="lg"
              >
                <StatLabel
                  bg="#1d5840"
                  fontWeight="medium"
                  fontSize="xl"
                  isTruncated
                >
                  <Text fontSize="xl" textAlign="center" fontWeight={700}>
                    Curva de Tradeoff - Ruptura % vs Custo Médio de Estoque
                  </Text>
                </StatLabel>
              </Box>
              <Box px={{ base: 1, md: 1 }} pt={3} pb={8}>
                <ChartTraydOff />
              </Box>
            </Flex>
          </Stat>
          <Box pt={4}>
            <Stat
              // px={{ base: 2, md: 4 }}
              // py={'5'}
              shadow={'xl'}
              border={'1px solid'}
              borderColor={useColorModeValue('gray.800', 'gray.500')}
              rounded={'lg'}
            >
              <Flex
                justifyContent={'space-between'}
                direction="column"
                alignItems="center"
              >
                <Box
                  bg="#1d5840"
                  color="white"
                  width="100%"
                  textAlign="center"
                  py={2}
                  roundedTop="lg"
                >
                  <StatLabel
                    bg="#1d5840"
                    fontWeight="medium"
                    fontSize="xl"
                    isTruncated
                  >
                    <Text fontSize="xl" textAlign="center" fontWeight={700}>
                      Estoque Simulado VS Perda de Venda
                    </Text>
                  </StatLabel>
                </Box>
                <Box px={{ base: 1, md: 1 }} pt={3} pb={8}>
                  <ChartSimuladoOne />
                </Box>
              </Flex>
            </Stat>
          </Box>
        </GridItem>
        {/* <GridItem pl="2" pb={4} colSpan={6} mr={9}>
          <Box border="1px solid" borderRadius={8} m={0} p={0}>
            <DataTable />
          </Box>
        </GridItem>
        <GridItem pl="2" pb={10} colSpan={6} mr={9}>
          <Box border="1px solid" borderRadius={8} m={0} p={0}>
            <DataTableOne />
          </Box>
        </GridItem> */}
        <GridItem pl="2" pb={4} colSpan={6} mr={9}>
          <Box border="1px solid" borderRadius={8} m={0} p={0}>
            <DataTableIndication />
          </Box>
        </GridItem>
      </Grid>
    </>
  )
}

export default Core3Otimizador
